import React from 'react';
import IndexPage from '@pages/Index';
import AboutPage from '@pages/About';
import CustomerPage from '@pages/Customers';
import SupplierPage from '@pages/Suppliers';
import FDAPage from '@pages/FDA';
import ProductPage from '@pages/Products';
import OrderFilesPage from '@pages/OrderFiles';
import NotFound from '@pages/NotFound';
import OrderCapacityPage from '@pages/OrderCapacity';
import { PathElement } from 'interfaces/route';
import {
  UserOutlined,
  ShopOutlined,
  SafetyCertificateOutlined,
  HomeOutlined,
  ShoppingOutlined,
  SettingOutlined,
  FileOutlined,
  ShoppingCartOutlined
} from '@ant-design/icons';
import OptionsManager from '@pages/OptionsManager';
import ContainerPage from '@pages/Containers';
import PalletsPage from '@pages/Pallets';
import PalletLayoutsPage from '@pages/PalletLayouts';

const paths: PathElement[] = [
  {
    key: 'home',
    label: 'Home',
    component: IndexPage,
    icon: HomeOutlined,
    path: '/pallet_calculator',
    showInMenu: true,
  },
  {
    key: 'suppliers',
    label: 'Suppliers',
    component: SupplierPage,
    icon: ShopOutlined,
    path: '/pallet_calculator/suppliers',
    showInMenu: true,
  },
  {
    key: 'fda',
    label: 'FDA Registrations',
    component: FDAPage,
    icon: SafetyCertificateOutlined,
    path: '/pallet_calculator/fda',
    showInMenu: true,
  },
  {
    key: 'products',
    label: 'Products',
    component: ProductPage,
    icon: ShoppingOutlined,
    path: '/pallet_calculator/products',
    showInMenu: true,
  },
  {
    key: 'customers',
    label: 'Customers',
    component: CustomerPage,
    icon: UserOutlined,
    path: '/pallet_calculator/customers',
    showInMenu: true,
  },
  {
    key: 'containers',
    label: 'Containers',
    component: ContainerPage,
    icon: ShoppingCartOutlined,
    path: '/pallet_calculator/containers',
    showInMenu: true,
  },
  {
    key: 'pallets',
    label: 'Pallets',
    component: PalletsPage,
    icon: FileOutlined,
    path: '/pallet_calculator/pallets',
    showInMenu: true,
  },
  {
    key: 'pallet-layouts',
    label: 'Pallet Layouts',
    component: PalletLayoutsPage,
    icon: FileOutlined,
    path: '/pallet_calculator/pallet-layouts',
    showInMenu: true,
  },
  {
    key: 'order-files',
    label: 'Order Files',
    component: OrderFilesPage,
    icon: FileOutlined,
    path: '/pallet_calculator/order-files',
    showInMenu: true,
  },
  {
    key: 'order-capacity',
    label: 'Order Capacity',
    component: OrderCapacityPage,
    path: '/pallet_calculator/order-capacity/:orderFileId',
    showInMenu: false,
  },

  {
    key: 'options',
    label: 'Options',
    component: OptionsManager,
    icon: SettingOutlined,
    path: '/pallet_calculator/options',
    showInMenu: true,
  },
  {
    key: 'notFound',
    label: 'Not Found',
    component: NotFound,
    path: '*',
  },
];

export default paths;
